export const COUNTRY_QUERY = /* GraphQL */ `
    query countries {
        countries {
            id
            two_letter_abbreviation
            full_name_locale
            full_name_english
            available_regions {
                id
                code
                name
            }
        }
    }
`
